import {apiLogin} from '@/api/login'
import Cookies from 'js-cookie'
import qs from 'qs'

export default {
  methods:{
    login(data){
      apiLogin({
        data: qs.stringify(data)
      }).then(res => {
        if (res.resultCode == 1) {
          this.$message.success('登录成功')
          //发送数据到vuex的事件里面，存储到本地和vuex数据里面。
          this.updateUserInfo({
            ...res.result,
          })
          //进入主页面的前一刻进行路由的守卫
          this.$router.push('/')
        } else {
          this.$message.error(res.errorMsg)
        }
      })
    }
  }
}
